import { useForm } from "react-hook-form";
import { CustomFormField } from "../../../../utilis/component/CustomFormElement";
import {
  Table,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  useTheme,
} from "@mui/material";
import CustomTableBody from "../../../../utilis/component/CustomTableBody";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { getAppointments } from "./service";
import moment from "moment";
// import { Cancel, Edit } from "@mui/icons-material"
import debounce from "../../../../utilis/methods/networkHandling";
import { FormOnChangeEventType } from "../../../../EMR/types";
import { getappointmentPayloadType } from "./type";

const Appointments = () => {
  const { control } = useForm();
  const theme = useTheme();
  const [searchPayload, setSearchPayload] = useState<getappointmentPayloadType>(
    {
      clinicId: 1,
      filter: {
        search: "",
        searchDate: moment().format("YYYY-MM-DD"),
        searchDateTo: moment().format("YYYY-MM-DD"),
      },
      pageNumber: 0,
      pageSize: 25,
      sortField: "",
      sortOrder: "asc",
    }
  );
  const { mutate: getAppointmentList, data: appointmentList } =
    useMutation(getAppointments);
  useEffect(() => {
    getAppointmentList(searchPayload);
  }, [searchPayload]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const pageSize = parseInt(event.target.value, 10);
    setSearchPayload((prev) => ({
      ...prev,
      pageNumber: 0,
      pageSize,
    }));
  };
  const handleChangePage = (_: unknown, pageNumber: number) => {
    setSearchPayload({
      ...searchPayload,
      pageNumber,
    });
  };
  const searchOnText = debounce((e: FormOnChangeEventType) => {
    setSearchPayload((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [e.target.name]: e.target.value,
      },
    }));
  }, 500);
  const searchAppointments = (e: FormOnChangeEventType) => {
    setSearchPayload((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [e.target.name]: e.target.value,
      },
    }));
  };

  return (
    <>
      <form>
        <div className="grid grid-cols-12 gap-2 my-2">
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="input"
              name="search"
              rules={{ required: false, onChange: searchOnText }}
              fieldProps={{ label: "search", type: "text" }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="datepicker"
              name="searchDate"
              dateFormat="YYYY-MM-DD"
              rules={{ required: false, onChange: searchAppointments }}
              fieldProps={{ label: "from Date" }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="datepicker"
              name="searchDateTo"
              dateFormat="YYYY-MM-DD"
              rules={{ required: false, onChange: searchAppointments }}
              fieldProps={{ label: "To Date" }}
            />
          </div>
        </div>
      </form>
      <Table size="small">
        <TableHead
          sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
        >
          <TableRow>
            {headings.map((item: string) => {
              return (
                <TableCell
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                >
                  {item}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>

        <CustomTableBody
          alert={"No Appointments"}
          dataLoading={false}
          isData={Boolean(appointmentList?.appointmentResults?.length)}
          totalSpan={{ col: 9, row: 3 }}
        >
         
          {appointmentList?.appointmentResults?.map(
            (item: any, index: number) => {
              return (
                <>
                  <TableRow>
                   <TableCell>{searchPayload.pageNumber * searchPayload.pageSize + (index + 1)}</TableCell>
                    <TableCell>{item.emrno}</TableCell>
                    <TableCell>{item.patientName}</TableCell>
                    <TableCell>{item.mobile}</TableCell>
                    <TableCell>{item.doctorName}</TableCell>
                    <TableCell>{item?.departmentName}</TableCell>
                    <TableCell>
                      {moment(item?.appStartTime).format(
                        "DD-MM-YYYY hh:mm A"
                      )}
                    </TableCell>
                    <TableCell>
                      {item?.status == 1 ? (
                        <span style={{ color: theme.palette.success.main }}>Active</span>
                      ) : (
                        <span style={{ color: theme.palette.error.main }}>Cancelled</span>
                      )}
                    </TableCell>
                  </TableRow>
                </>
              );
            }
          )}
        </CustomTableBody>
      </Table>
      <TablePagination
        count={appointmentList?.totalCount || 0}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPage={searchPayload.pageSize || 0}
        page={searchPayload.pageNumber || 0}
      ></TablePagination>
    </>
  );
};

export default Appointments;

const headings = [
  "Sl No",
  "EMR No/Reg No",
  "Patient Name",
  "Mobile No",
  "Doctor Name",
  "Department",
  "Appointment tIme",
  "Status",
];
